import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {FactoryBankDetails} from "../../types/factory-bank-details-modal.types";
import {MatIcon} from "@angular/material/icon";
import {MatMiniFabButton} from "@angular/material/button";

@Component({
  selector: 'app-factory-bank-details-title',
  imports: [
    MatIcon,
    MatMiniFabButton
  ],
  templateUrl: './factory-bank-details-title.component.html',
  styleUrl: './factory-bank-details-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FactoryBankDetailsTitleComponent {
  data = input.required<FactoryBankDetails>();
  isEditModeActive = input.required<boolean>();
  handleDelete = output<MouseEvent>();
}
